import React, {useState} from "react";
import {
    AppBar,
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    Fade,
    IconButton,
    Link,
    Modal,
    TextField,
    Toolbar
} from "@material-ui/core";
import {Close, Menu,} from "@material-ui/icons";

// styles
import useStyles from "./styles";
import jobninja from "../../images/jn.svg";

// components
import {Typography} from "../Wrappers/Wrappers";

// context
import {logout} from "../../datamanagement/actions";
import {connect} from "react-redux";
import CopyToClipboard from "../../pages/jobdashboard/components/CopyToClipboard";
import withWidth, {isWidthUp} from "@material-ui/core/withWidth";
import Grid from "@material-ui/core/Grid";
import {toggleSidebar, useLayoutDispatch} from "../../context/LayoutContext";

function Header(props) {
    var classes = useStyles();

    const [modalOpen, setModalOpen] = useState(false)

    const handleModalClose = () => {
        setModalOpen(false)
    }

    const modalText = `Hallo JobNinja-Team,

wir würden gerne einen weiteren Job auf der Plattform ausschreiben. 

Jobtitel: [BITTE FÜGEN SIE DIE GEWÜNSCHTE BERUFBEZEICHNUNG HINZU]

Standort(e): [BITTE FÜGEN SIE DIE ORTE HINZU, AN DENEN SIE DIE STELLE AUSSCHREIBEN MÖCHTEN] 

[BITTE FÜGEN SIE DAS NEUE HTML/ZIP/PDF/DOCX IN IHRER E-MAIL AN].

Beste Grüße,`

    const rowsMax = () => {
        const length = modalText.split(/\r\n|\r|\n/).length;
        if (isWidthUp('md', props.width)) {
            return length + 2;
        }
        return 3
    }

    var layoutDispatch = useLayoutDispatch();


    return (
        <>
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar className={classes.toolbar}>

                    <Grid container justify={'center'} alignItems={'center'}>
                        <IconButton onClick={() => {
                            toggleSidebar(layoutDispatch);
                        }} className={classes.toggle}>
                            <Menu/>

                        </IconButton>
                        <Link to={'/app/dashboard'}><img src={jobninja} alt="Logo" className={classes.logotype}/></Link>
                        <div className={classes.grow}/>
                        {!!props.user.isAuthenticated &&
                        <Box>
                            <Button onClick={() => setModalOpen(true)} variant={"contained"} color={"secondary"}
                                    className={classes.purchaseBtn}>
                                Job hinzufügen
                            </Button>
                            <Button onClick={() => props.logout(props.history)} variant={"contained"}
                                    color={"secondary"}
                                    className={classes.purchaseBtn}>
                                Abmelden
                            </Button>
                        </Box>}
                    </Grid>
                </Toolbar>
            </AppBar>
            <Modal
                open={modalOpen}
                onClose={handleModalClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <Fade in={modalOpen} timeout={500}>
                    <Card className={classes.modalRoot}>
                        <IconButton onClick={handleModalClose} className={classes.modalExit}>
                            <Close/>
                        </IconButton>
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="h2">
                                Anzeige anpassen
                            </Typography>
                            <Typography variant="body2" color="textSecondary" component="p">
                                Damit wir Ihre Anfrage schneller bearbeiten können, bitten wir Sie den unten
                                stehenden Text zu kopieren, entsprechend Ihren Bedürfnissen abzuändern und an <a
                                href={'mailto:anzeigen@jobninja.com'}
                                target={'_blank'} rel="noopener noreferrer">anzeigen@jobninja.com</a> zu senden.
                            </Typography>
                            <br/>
                            <TextField
                                label="Ihre E-Mail"
                                multiline
                                disabled
                                rowsMax={rowsMax()}
                                value={modalText}
                                fullWidth
                                variant="outlined"
                            />
                        </CardContent>
                        <CardActions>
                            <CopyToClipboard TooltipProps={{placement: 'right'}}>
                                {({copy}) => (
                                    <Button
                                        variant="contained"
                                        size="medium"
                                        color="secondary"
                                        onClick={() => copy(modalText)}
                                    >Text kopieren
                                    </Button>
                                )}
                            </CopyToClipboard>
                        </CardActions>
                    </Card>
                </Fade>
            </Modal>
        </>


    );
}

const mapStateToProps = ({user}) => {
    return {user};
}


const mapDispatchToProps = dispatch => {
    return {
        logout: (history) => logout(dispatch, history),
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(withWidth()(Header));